<p *ngIf="!forumquestions || forumquestions.length === 0">Start a Discussion</p>
<form *ngIf="!parentId" (ngSubmit)="addQuestion()" style="margin-bottom: 1%;">
  <label for="chat-form__text-field" class="sr-only">{{chatSectionLabel}}</label>
  <div class="d-flex justify-content-center">
    <textarea name="chat-form__text-field" id="chat-form__text-field" [(ngModel)]="newquestion.text"
      class="chat-form__text-field2 p-2"
      placeholder="{{chatSectionLabel}}" autofocus></textarea>
    <button [disabled]="loading"
      class="btn bg-white mx-2" title="Post">Create</button>
  </div>
</form>

<div #forumWrap class="forum-wrap mx-auto d-flex flex-column"
  [style]="'height: ' + 'calc(100vh - ' + forumWrap.offsetTop + 'px - var(--main-padding)' + (!screenSizeIsMediumAndAbove ? ' - var(--icon-nav-height))' : '')"> 
  <div class="flex-fill overflow-auto" #forumContainer>
    <div class="px-2">
      <ul *ngIf="forumquestions && forumquestions.length > 0" class="list-group list-group-flush list ">
        <li class="list-group-item px-0 bg-transparent" *ngFor="let comment of forumquestions">
          <app-forumtemplate [data]="{question:comment, pageid:id, moduleid:moduleid}"
            (deleteComment)="deletediscussion($event)" (clearcommenttextarea)="clearcommenttextarea($event)"
            (replyClicked)="onReplyClicked($event)">
          </app-forumtemplate>
        </li>
      </ul>  
    </div>
  </div>    
  <form *ngIf="parentId" (ngSubmit)="addQuestion()" class="chat-form mt-1">
    <label for="chat-form__text-field" class="sr-only">{{chatSectionLabel}}</label>
    <div class="d-flex h-100">
      <textarea name="chat-form__text-field" id="chat-form__text-field" [(ngModel)]="newquestion.text"
        class="chat-form__text-field"
        placeholder="{{chatSectionLabel}}" autofocus></textarea>
      <button [disabled]="loading"
        class="chat-form__btn fa fa-paper-plane bg-white" title="Post"></button>
    </div>
  </form>
</div>